
import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner } from 'react-bootstrap';
import Markdown from 'marked-react';
import './nextgpt.scss';

function TrainingPlans() {
    let accumulatedData = '';
    let remainedData = null;

    const [genstateTP, setGenstateTP] = useState('notgen');
    const [trainingPlansData, setTrainingPlansData] = useState('');
    const [isSendtoRM, setSendToRM] = useState(false);

    var trainingPlansData_local = localStorage.getItem('trainingPlansData_local');
    useEffect(() => {
        if (trainingPlansData_local !== null) {
            if (genstateTP ==='notgen'){
                document.getElementById('generatingBtn').style.visibility = 'hidden';
                document.getElementById('generatingBtn').style.display = 'none';
                setSendToRM(true);
            } 
            setTrainingPlansData(trainingPlansData_local);
        }

    }, [trainingPlansData_local])

    const callNextGpt = async (usecase, file) => {
        var dataResponse;

        const formData = new FormData();
        const blob = await fetch(file)
        const data = await blob.blob();
        const transcriptUsed = localStorage.getItem('transcript');
        if (transcriptUsed === 'mixed')
            formData.append('transcript', new File([data], "/bank_rm_transcript_mixed.txt"));
        else 
            formData.append('transcript', new File([data], "/bank_rm_transcript.txt"));

        const accessToken = 'vehzcryR9jKk6ImttBLXQHS_dQn0etD5kdM-yeBQots';
        const apiUrl = 'https://nextgpt.southeastasia.cloudapp.azure.com/_api/api/v1/models/' + usecase + '/session';

        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
            body: formData
        })
            .then(response => {
                return response.text();
            })
            .then(data => {
                dataResponse = data;
                callSession(data, usecase);
                // console.log(data);
                // setSessionId(data);
                // fun(data, usecase)
            })
            .catch(error => {
                console.error('There was a problem with your fetch operation:', error);
            });

        return dataResponse;
    };

    const callSession = (session_id, usecase) => {
        const accessToken = 'vehzcryR9jKk6ImttBLXQHS_dQn0etD5kdM-yeBQots';
        const apiUrl = 'https://nextgpt.southeastasia.cloudapp.azure.com/_api/api/v1/chat/completions?debug=false&session_id=' + session_id;

        const stream = new ReadableStream({
            start(controller) {
                const processResponse = async (response, controller) => {
                    const reader = response.body.getReader();
                    let { done, value } = await reader.read();
                    while (!done) {
                        processChunk(new TextDecoder().decode(value), controller, usecase);
                        ({ done, value } = await reader.read());
                    }
                };

                fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "model": usecase,
                        "messages": [
                            {
                                "role": "system"
                            }
                        ],
                        "max_tokens": 1000,
                        "temperature": 0,
                        "stream": true
                    })
                })
                    .then(response => processResponse(response, controller))
                    .catch(error => console.error('Error fetching data:', error));
            }
        });
    };

    const processChunk = (chunk, controller, usecase) => {
        chunk = remainedData + chunk;

        var chunkArray = chunk.split('\n');
        chunkArray.forEach((item, index) => {
            if (item.includes('choices')) {

                const jsonData = item.split('data: ')[1];
                try {
                    const data = JSON.parse(jsonData);
                    if (data.choices.length > 0) {

                        if (data.choices[0].finish_reason === "stop") {
                            document.getElementById('generatingBtn').style.visibility = 'hidden';
                            document.getElementById('generatingBtn').style.display = 'none'; 
                            setSendToRM(true); 
                            return;
                        }

                        const newContent = data.choices[0].delta.content;
                        accumulatedData += newContent;
                        console.log(accumulatedData);
                    }

                } catch (e) {
                    if (e === "[DONE]") {
                        controller.close();
                        return;
                    }
                }
            } else {
                remainedData = item;
                // setRemainedData(item);
                if (usecase === "Bank_Training Program API") {
                    setTrainingPlansData(accumulatedData);
                    localStorage.setItem('trainingPlansData_local', accumulatedData);
    
                } 
            }
        });
    };
    const trainingPlans = () => {
        toggleGenStateTP()
        //callNextGpt("Bank_Training Program API", "/bank_rm_transcript.txt");
        const transcriptUsed = localStorage.getItem('transcript');
        if (transcriptUsed === 'mixed')
            callNextGpt("Bank_Training Program API", "/bank_rm_transcript_mixed.txt");
        else 
            callNextGpt("Bank_Training Program API", "/bank_rm_transcript.txt");
    }
    const toggleGenStateTP = () => {
        setGenstateTP(prevState => (prevState === 'notgen' ? 'gen' : 'notgen'));
    };

    return (
        <div>
            <Row className='perf_breakdown'>
                <Col><h5>Recommended Training Plans</h5></Col>
                <Col className='buttoncol'>
                    <div id="generatingBtn">  
                        <button className={`btn ${genstateTP}`} onClick={trainingPlans}>
                            {genstateTP === 'notgen' ? (
                                <div className='notgen'>Training Plans</div>
                            ) : (
                                <div className='gen'>
                                    <Spinner animation="border" size="sm" />Generating
                                </div>
                            )}
                        </button>
                    </div>
                    {
                        isSendtoRM === true && 
                        <button className='btn sendToRm' id="sendToRm">Send to RM's LMS account,<br/> Flag as Mandatory</button>
                    } 
                </Col>
            </Row>
            <Row>
                <div className="trainingPlansTable">
                    <Markdown>{trainingPlansData}</Markdown>
                </div>
            </Row>
        </div>
    )
}

export default TrainingPlans;